export const BRAND = {
    name: "Veeras Resorts and Hospitality",
    short: "Veeras Resorts",
    phone: "9945888183",
    phone2: "9741535246",
    phoneIntl: "+91 9945888183",
    phone2Intl: "+91 9741535246",
    whatsappNumber: "919945888183",
    email: "sharath.veeras@gmail.com",
    address: "WQGM+79 Sakleshpura, Karnataka",
    locationShort: "Sakleshpur · Western Ghats",
};

export const whatsappLink = (text = "Hi, I'd like to book a stay at Veeras Resorts.") =>
    `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(text)}`;

export const IMG = {
    heroNightPool: "https://customer-assets.emergentagent.com/job_27255fff-27a7-4698-b219-b820e248fc8a/artifacts/2puc96yw_main%20image.jfif",
    pathNight: "https://customer-assets.emergentagent.com/job_27255fff-27a7-4698-b219-b820e248fc8a/artifacts/f5yxxd4p_image%202.jfif",
    pathDay: "https://customer-assets.emergentagent.com/job_27255fff-27a7-4698-b219-b820e248fc8a/artifacts/oxxhcsss_main%203.jfif",
    cottages: "https://customer-assets.emergentagent.com/job_27255fff-27a7-4698-b219-b820e248fc8a/artifacts/22nqdggx_main%20image%202.jfif",
    poolCouple: "https://customer-assets.emergentagent.com/job_27255fff-27a7-4698-b219-b820e248fc8a/artifacts/wzutev6y_veeras%20swiming%203.jfif",
    coffeeEstate: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/tbmjrpaf_cofee%20estate%20veeras.jfif",
    coffeeCup: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/hex03erp_veeras%20coffee.jfif",
    poolDay: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/co1ugo9e_veeras%20swimmimg%20pool2.jfif",
    poolNightWide: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/ivn992a0_swimming%20night.jfif",
    poolCheers: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/o9nhlj0d_swimmimg%203.jfif",
    diningNight: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/g4gm5ujj_dinning%2001.jfif",
    diningDay: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/i6vtbrbz_dinning%202.jfif",
    diningHall: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/uz0uajo8_dinning3.jfif",
    guestsFood: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/15uv36tw_image3.jfif",
    veerasFood: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/bc9topja_veeras%20food.jfif",
    bottlesNight: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/9g0rpd4g_bottals.jfif",
    bottlesDay: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/blyoea12_bottals%202.jfif",
    malnadHeritage: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/3g3qi16y_malnad%20agri.jfif",
    campfireReal: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/cly7vlgu_image5.jfif",
    realRoom1: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/2zjf5gv6_veeras%20room1.jfif",
    realRoom4: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/4fappkpi_rooms%204.jfif",
    realRoom5: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/p55jdghv_rooms%205.jfif",
    realParty: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/bfudbseo_party.jfif",
    realBirthday: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/pcgt1zkd_birthday.jfif",
    logo: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/1e5vpm2q_logo.jpg",
    estatePath2: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/5lbtk2d4_coffee%20plantation%202.jpg",
    cottagePath2: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/20ug0459_Cottage%20pathway%202.jpg",
    poolGroup: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/qm4gr1nl_Pool%204.jpg",
    poolSunset: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/6c9l6nii_Pool%205.jpeg",
    projector: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
    carRent: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/nlfmf0a7_cars.jfif",
    bikeRent: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/3rblbve1_baik.jfif",
    coffeeTable: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/k8j4hv29_coffee%20table.jpg",
    award1: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/yd6dfucq_award%202.jfif",
    award2: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/tl7n5jy8_award3.jfif",
    award3: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/rds09t73_award4.jfif",
    award4: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/9gt2c5dy_prize1.jfif",
    diningNew1: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/12c3i180_dinning%20new.jfif",
    diningNew2: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/gugrqp7n_dinning%20new%202.jfif",
    bottleNew: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/cqili32d_bottle%20new.jfif",
    gamesAll: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/i69bbkit_games%20all.jfif",
    marriageFunction: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/g73v5c1d_marrege%20function.jfif",
    groupRoom: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/nxwz1xeg_group%20room.jfif",
    cottageRoom: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/kq312k31_veeras%20room1.jfif",
    familyFunction: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/hwvm0a2i_family%20function.jfif",
    poolDayCollage: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/lrx76b0x_swmiing%20day%20new.jfif",
    poolNightCollage: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/plzsh3wg_swming%20pool%20night%20new%2001.jfif",
    malnadAntiqueWall: "https://customer-assets.emergentagent.com/job_veeras-resorts/artifacts/e9kzdag5_VEERAS%20MALNAD%20HERETAGE.jfif",
    vintage: "https://images.pexels.com/photos/32618288/pexels-photo-32618288.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    roomFamily: "https://images.pexels.com/photos/14025911/pexels-photo-14025911.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    roomCouple: "https://images.unsplash.com/photo-1737531049186-a20c1f203f50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxydXN0aWMlMjBsdXh1cnklMjBiZWRyb29tJTIwcmVzb3J0fGVufDB8fHx8MTc3NjkyNTg4OXww&ixlib=rb-4.1.0&q=85",
    roomCottage: "https://images.pexels.com/photos/17399357/pexels-photo-17399357.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    mistyMountains: "https://images.pexels.com/photos/12299536/pexels-photo-12299536.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    dining: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&w=1200&q=80",
    campfire: "https://images.unsplash.com/photo-1475139441338-693e7dbe20b6?auto=format&fit=crop&w=1200&q=80",
    games: "https://images.unsplash.com/photo-1518609878373-06d740f60d8b?auto=format&fit=crop&w=1200&q=80",
    event: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1200&q=80",
};

export const ROOMS = [
    {
        id: "family",
        title: "Family Retreat",
        subtitle: "For 4–6 guests",
        image: IMG.groupRoom,
        features: ["Spacious layout", "Estate views", "Attached bath · 24-hr hot water", "Ideal for families & small groups"],
    },
    {
        id: "couple",
        title: "Couple Escape",
        subtitle: "For 2 guests",
        image: IMG.realRoom4,
        features: ["Intimate, rustic luxury", "Signature stained-glass wheel window", "Private sit-out", "Ideal for honeymoons & anniversaries"],
    },
    {
        id: "cottage",
        title: "Private Cottage",
        subtitle: "Standalone stay",
        image: IMG.cottageRoom,
        features: ["Standalone cottage inside the estate", "Brick-and-wood interiors", "Private veranda", "Deep quiet & stars above"],
    },
];

export const FEATURES = [
    {
        title: "Coffee-Wood Dining Hall",
        body: "Hand-built from pure Malnad coffee wood. Every table is a slab from the estate's own century-old coffee trees — each grain a quiet record of monsoons, mist and harvests. Surrounded by hanging cart-wheels, ferns and warm Malnad light, every meal here feels like an heirloom.",
        image: IMG.diningDay,
    },
    {
        title: "150-Year Malnad Heritage",
        body: "A living museum of the hills. Original ploughs, pestles, lanterns, yokes and cart-wheels that worked these slopes over a century and a half ago — all untouched, all on quiet display. Our small bow to the farmers who came before us.",
        image: IMG.malnadHeritage,
    },
    {
        title: "Night Campfire",
        body: "Evenings turn into stories. Gather around the bonfire under a canopy of stars — strumming guitars, hot Malnad coffee and the soft crackle of wood. The kind of nights you remember for years.",
        image: IMG.campfireReal,
    },
    {
        title: "Indoor & Outdoor Activities",
        body: "Eleven different ways to forget your phone — from rain-dance and slush volleyball to chess, snooker and a real zip-line. Built for every kind of guest, every kind of mood.",
        image: IMG.games,
    },
    {
        title: "Night Lights of Veeras",
        body: "Hand-lit pathways, glowing wheels and lantern canopies — a property that quietly transforms into a fairyland after dusk.",
        image: IMG.pathNight,
    },
];

export const ACTIVITIES = [
    "Swimming Pool",
    "Slush Volleyball",
    "Foosball",
    "Rain Dance",
    "Carrom",
    "Shuttle Badminton",
    "Cricket",
    "Zip Line",
    "Commando Adventure Net",
    "Chess Board",
    "Snooker / Pool Board *",
];

export const REVIEWS = [
    { name: "Sneha", rating: 5, text: "A wonderful stay at Veeras — beautifully located amidst nature, calm and peaceful. Perfect for relaxation." },
    { name: "Shilpa", rating: 5, text: "We were a group of 20 and absolutely enjoyed our New Year stay. Rooms tidy, food excellent with many local dishes." },
    { name: "Aarti Mohta", rating: 5, text: "Amazing cozy stay. Lush greenery, delicious home-cooked food, customized tea and genuine hospitality." },
    { name: "Dinesh Reddy", rating: 5, text: "Outstanding! Spacious, spotless rooms with the perfect blend of comfort and luxury. Top-notch service." },
    { name: "Lavanya M C", rating: 5, text: "A beautiful homestay nestled inside a coffee estate. Clean rooms, great food, 24-hour hot water and the pool." },
    { name: "Srinivas Kumar", rating: 5, text: "Awesome experience. Amazed with the reception, presentations and innovative objects placed around the property." },
    { name: "Ananya", rating: 5, text: "Surrounded by a coffee estate with a very relaxing vibe. Warm staff, tasty food, pool and engaging activities." },
    { name: "Dhanush Gowda", rating: 5, text: "Vintage ambiance in a peaceful coffee estate. Clean pool, zip line and many activities made it memorable." },
    { name: "Ramesh Ganapayya", rating: 5, text: "A delightful budget-friendly homestay with lush surroundings. The pool was our favourite spot to unwind." },
    { name: "Samhitha M C", rating: 5, text: "Serene coffee estate, clean rooms, great food and a calming ambiance. A perfect blend of nature and warmth." },
    { name: "Vignesh", rating: 5, text: "Excellent blend of comfort and authenticity. Friendly hosts always ready to help. Well located." },
    { name: "Manjunatha Pai", rating: 5, text: "Surrounded by green — a treat to the eyes. Good food and service make it a nice weekend place." },
    { name: "Mohammed Zibran", rating: 5, text: "Excellent experience. Yuvraj was so friendly. A best weekend destination for nature, fresh air and calmness." },
];

export const NEARBY = [
    { name: "Bisle Ghat View Point", image: "https://commons.wikimedia.org/wiki/Special:FilePath/Bisle_ghat_view_point.jpg?width=1280", note: "Panoramic Western Ghats overlook" },
    { name: "Manjarabad Fort", image: "https://commons.wikimedia.org/wiki/Special:FilePath/Manjarabad_fort.jpg?width=1280", note: "Star-shaped heritage fort by Tipu Sultan" },
    { name: "Bisle Reserve Forest", image: "https://commons.wikimedia.org/wiki/Special:FilePath/Bisle.jpg?width=1280", note: "Lush evergreen Western Ghats" },
    { name: "Green Route Railway", image: "https://commons.wikimedia.org/wiki/Special:FilePath/Train_enroute_green_route.JPG?width=1280", note: "Scenic heritage railway line" },
    { name: "Belur Chennakeshava Temple", image: "https://commons.wikimedia.org/wiki/Special:FilePath/Chennakesava_Temple,_Belur_03.jpg?width=1280", note: "12th-century Hoysala UNESCO marvel" },
];

export const EVENTS = [
    { title: "Private Parties", image: IMG.realParty },
    { title: "Birthdays", image: IMG.realBirthday },
    { title: "Traditional Weddings", image: IMG.marriageFunction },
    { title: "Family Functions", image: IMG.familyFunction },
    { title: "Corporate Meetings", image: IMG.projector },
];
